import axios from "@/utils/api.request"
/**
 * 通用结果处理
 * @param {*} res
 */
 function callBack(res) {
  const { data, status } = res
  try {
    const { flag, data: response, message } = data
    // 操作成功（返回数据）
    if (flag) {
      return response
    }
    // 操作失败
    throw message
  } catch (error) {
    console.error(status)
    throw error
  }
}

/**
 * @api
 * 查询分页列表
 */
 export async function queryPageList(current = 1, size = 10, value) {
  // 构造data
  const data = { current, size }
  if (value) {
    Object.assign(data, value)
  }
  // 请求
  return axios.request({
    url: 'bulletin/queryPageList',
    data,
    method: 'post'
  }).then(callBack)
}

//保存或修改单条文件
export const saveOrUpdate = (bFile) => {
    return axios.request({
      url: 'bulletin/saveOrUpdate',
      data: bFile,
      method: 'post',
      headers:{
        "Content-Type": "application/json"
      }
    })
  }
export const deleteById = (id) => {
    return axios.request({
        url: 'bulletin/deleteById',
        params: {
            'id': id
        },
        method: 'post'
    })
}

  /**
 * 查询详情
 */
 export const getOneById = (id) => {
  return axios.request({
    url:  'bulletin/getOneById',
    data: id,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(callBack)
}

export const deleteByIds = (ids) => {
  return axios.request({
    url: 'bulletin/deleteByIds',
    data: ids,
    method: 'post'
  })
}
  //查询成果列表
export const queryAchievementsList = (type) => {
  return axios.request({
    url: 'bulletin/queryAchievementsList',
    data: type,
    method: 'post',
    
  }).then(callBack)
}
